import { useMemo } from 'react';
import { createAdminClient, type AdminClient } from '../api/client.js';
import { useAuth } from '../auth/AuthContext.js';

/**
 * Bind a single {@link AdminClient} to the current auth session. The client reads the access token
 * through the getter on each request, so silent refresh is transparent (§32.3).
 */
export function useAdminClient(): AdminClient {
  const { getAccessToken } = useAuth();
  return useMemo(() => createAdminClient(getAccessToken), [getAccessToken]);
}
